import React from 'react';
import LoanProgramTemplate from './LoanProgramTemplate';

export default function FHALoanPage() {
  return (
    <LoanProgramTemplate
      title="FHA Loans"
      subtitle="Our Loan Programs"
      heroImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1778098866/in-flight_3_n3rham.png"
      contentImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1777907327/FHA_akegne.png"
      descriptionBold="FHA loans"
      description="are insured by the Federal Housing Administration and offer flexible qualification standards designed to support a wide range of buyers."
      whyBuyersConsider="FHA loans can make qualifying easier for buyers with limited savings or lower credit scores, offering a more accessible path to homeownership."
      eligibilityItems={[
        'Minimum credit score requirements apply',
        'Down payments start at 3.5 percent for eligible credit tiers',
        'Income and employment must be documented and steady',
        'Home must be a primary residence',
        'FHA mortgage insurance applies to all loans',
      ]}
      benefitsItems={[
        'Lower minimum down payment options',
        'Competitive interest rates across most credit tiers',
        'Higher debt-to-income limits available',
        'Loans may be assumable for qualifying buyers',
      ]}
    />
  );
}
